import { render, staticRenderFns } from "./MainPayAuthority.vue?vue&type=template&id=37f1cd9f&scoped=true"
import script from "./MainPayAuthority.vue?vue&type=script&lang=ts"
export * from "./MainPayAuthority.vue?vue&type=script&lang=ts"
import style0 from "./MainPayAuthority.vue?vue&type=style&index=0&id=37f1cd9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1cd9f",
  null
  
)

export default component.exports